import React from 'react';
import {
  TEDLRAttestmeddelandeMOTTAGAR_TYPEnum,
  TEDLRFakturaAttestTYPEnum,
} from '../../../../../../../globalQueryTypes';
import {
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel,
} from '../../Queries/_QueryTypes/FakturaDelQuery';
import { IFieldValidations } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { FakturaDelType__Associations_Faktura__Associations_Attestmeddelande_All } from '../../Queries/_QueryTypes/FakturaDelType';
import { TEDLRFakturaAttestAttestTypEnum } from '../../../../../../../globalQueryTypes';
import { AllCertifiers_db_LRAttestratt_All } from '../FakturaAttestHandleCertifiersModal/Queries/_QueryTypes/AllCertifiers';
import { FormUpdateAssociatonType } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { IAktuellFakturaAttestInfo } from '../../Utils/FakturadelUtils';
import { IValues } from '../../../../../_StandardRutin/Mutations/ObjectMutations/ObjectUpdateMutationBase';

export interface IFakturaDelContext {
  activeKF: string;
  addAttestMessage: (
    message: string,
    id: string,
    time?: string,
    reciverID?: string,
    mottagarTyp?: TEDLRAttestmeddelandeMOTTAGAR_TYPEnum
  ) => void;
  allAttestanterOnAllParts: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[];
  getAttestMessageUpdateValue: (
    message: string,
    id: string,
    time?: string,
    reciverID?: string
  ) => FormUpdateAssociatonType[][];
  addFakturaattest: (
    addedAttestanter: AllCertifiers_db_LRAttestratt_All[],
    certificateType: TEDLRFakturaAttestAttestTypEnum
  ) => FormUpdateAssociatonType[][];
  addOrUpdateKonteringsforslag: (
    kontforslagUpdateObj: IKonteringsforslagUpdateObject,
    isAdded: boolean,
    associatedObject: FormUpdateAssociatonType[],
    ignoreFormHasChanged?: boolean
  ) => void;
  getAktuellFakturadel: () =>
    | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel
    | undefined;
  getFakturadel: (
    fakturaattest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
  ) =>
    | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel
    | undefined;
  getAllAttestanter: () => FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[];
  getAttestanter: (
    type: TEDLRFakturaAttestAttestTypEnum
  ) => FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[];
  attestMessages: FakturaDelType__Associations_Faktura__Associations_Attestmeddelande_All[];
  beslutsAttestanterAllaFakturadelar: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[];
  bokfDatum: Date;
  deleteOrUndoAttestMessage: (id: string, undoToLatestMessage?: string) => void;
  deleteFakturaattest: (
    deletedAttestanter: AllCertifiers_db_LRAttestratt_All[],
    certificateType: TEDLRFakturaAttestAttestTypEnum
  ) => FormUpdateAssociatonType[][];
  deleteKonteringsforslag: (
    newBeloppChanged: string | null,
    fakturaforslagId: string,
    setNewBeloppChangedId: (value: React.SetStateAction<string | null>) => void,
    ignoreFormHasChanged?: boolean
  ) => void;
  deletedKFs: string[];
  fakturaBelopp: number;
  fakturaId: string;
  kodplanId: string;
  konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[];
  getOriginKonteringsforslag: (
    konteringsforslagId: string
  ) => FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null;
  minFakturaAttest: IAktuellFakturaAttestInfo;
  setActiveKF: React.Dispatch<React.SetStateAction<string>>;
  setBeslutsattestant: (
    konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
    fakturaattest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All | null,
    isAdded: boolean,
    ignoreFormHasChanged?: boolean
  ) => void;
  isBeslutsattestantChanged: (
    konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
  ) => boolean;
  isKobFaktura: boolean;
  setBelopp: (
    konteringsforslagId: string,
    newValue: string,
    isAdded: boolean,
    saknarKontering: boolean,
    setNewBeloppChange: (id: string | null) => void,
    validationErrorMessage?: IFieldValidations
  ) => void;
  setBeloppExklMoms: (
    konteringsforslagId: string,
    newValue: string,
    isAdded: boolean,
    setNewBeloppChange: (id: string | null) => void
  ) => void;
  getBeloppInklMomsFormValue: (
    konteringsforslagId: string,
    newValue: string,
    setNewBeloppChange: (id: string | null) => void
  ) => IValues | null;
  isBeloppChanged: (
    konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
  ) => boolean;
  setKontodel: (
    konteringsforslagId: string,
    newValue: string,
    lopnr: number,
    kodplanId: string,
    bokfDatum: Date,
    isAdded: boolean,
    isFIactive: boolean,
    isFakturaBeloppLowerThanPeriodiseringBeloppEnhet: boolean
  ) => void;
  getKostnadsBeloppFormValue: (
    konteringsforslagId: string | undefined,
    konteringsforslagDebet: number | null | undefined,
    konteringsforslagKredit: number | null | undefined,
    setNewBeloppChange: (id: string | null) => void,
    radtyp: number | null | undefined,
    beloppInklMoms: number,
    beloppExklMoms: number,
    ingMomsSats: number | null | undefined,
    avdragsratt: number,
    customIngMomsBelopp: number | null | undefined,
    utlandskMomsSats: number | null | undefined,
    utlandskMomsBelopp: number | null | undefined
  ) => IValues;
  isKontodelChanged: (
    konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
    currentKontodelId: string,
    lopnr: number
  ) => boolean;
  beslutsattestByKonteringsforslag: (
    konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null
  ) => FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All | null;
  innehallerFleraFakturadelar: boolean;
  jagAttesterar: boolean;
  iAmStandin: (userSign: string) => IStandinInfo | null;
  readMessage: (messageID: string) => void;
}

export interface IKonteringsforslagUpdateObject {
  id: string;
  DEBET?: number;
  KREDIT?: number;
  BELOPP_EXKL_MOMS?: number;
  BELOPP_INKL_MOMS?: number;
  SORTERINGS_NR: number;
  RADTYP: number;
  UTL_MOMS?: number;
  UTL_MOMS_SATS?: number;
  UTL_MOMS_AVDRAG?: number | null;
  _Associations?: {
    Faktura_Ref: string;
  };
}

export interface IStandinInfo {
  reserv: boolean;
  reservFor: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All;
  attestOmradeId: string;
  typ: TEDLRFakturaAttestTYPEnum;
}

const defaults: IFakturaDelContext = {
  activeKF: '',
  addAttestMessage: () => {},
  getAttestMessageUpdateValue: () => [],
  addFakturaattest: () => [],
  getAllAttestanter: () => [],
  getAttestanter: () => [],
  attestMessages: [],
  deleteOrUndoAttestMessage: () => {},
  deleteFakturaattest: () => [],
  deletedKFs: [],
  konteringsforslag: [],
  getAktuellFakturadel: () => undefined,
  getFakturadel: () => undefined,
  getOriginKonteringsforslag: () => null,
  fakturaBelopp: 0,
  minFakturaAttest: {} as IAktuellFakturaAttestInfo,
  deleteKonteringsforslag: () => {},
  addOrUpdateKonteringsforslag: () => {},
  setActiveKF: () => {},
  setBeslutsattestant: () => {},
  isBeslutsattestantChanged: () => false,
  isKobFaktura: false,
  setBelopp: () => {},
  setBeloppExklMoms: () => {},
  getBeloppInklMomsFormValue: () => null,
  getKostnadsBeloppFormValue: () => ({}),
  isBeloppChanged: () => false,
  setKontodel: () => {},
  isKontodelChanged: () => false,
  kodplanId: '',
  fakturaId: '',
  bokfDatum: new Date(),
  beslutsattestByKonteringsforslag: () => null,
  beslutsAttestanterAllaFakturadelar: [],
  allAttestanterOnAllParts: [],
  innehallerFleraFakturadelar: false,
  jagAttesterar: false,
  iAmStandin: () => null,
  readMessage: () => {},
};

const FakturaDelContext = React.createContext<IFakturaDelContext>(defaults);

export default FakturaDelContext;
